import { SVGProps } from 'react'

const WhatsApp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Capa_1"
    x={0}
    y={0}
    viewBox="0 0 60 60"
    width="1em"
    height="1em"
    fill="currentColor"
    {...props}
  >
    <path
      id="XMLID_140_"
      d="M47.2 29.1C47 20 39.5 12.7 30.3 12.7c-9.1 0-16.5 7.1-16.9 16.1v.7c0 3.2.9 6.1 2.4 8.7l-3.1 9 9.4-3c2.4 1.3 5.2 2.1 8.2 2.1 9.4 0 16.9-7.5 16.9-16.8.1-.1.1-.2 0-.4zM30.3 43.7c-2.9 0-5.6-.9-7.8-2.3L17 43.1l1.8-5.3c-1.7-2.3-2.7-5.2-2.7-8.3 0-.5 0-.9.1-1.4.7-7.2 6.8-12.8 14.2-12.8 7.5 0 13.6 5.7 14.2 13v1.1c0 8-6.4 14.3-14.3 14.3z"
    />
    <path
      id="XMLID_139_"
      d="M38.1 32.9c-.4-.2-2.5-1.2-2.8-1.3-.4-.1-.7-.2-.9.2-.3.4-1.1 1.3-1.3 1.6-.2.3-.5.3-.9.1-.4-.2-1.8-.6-3.3-2-1.2-1.1-2.1-2.4-2.3-2.8-.2-.4 0-.6.2-.8.2-.2.4-.5.6-.7l.2-.2c.1-.2.2-.3.3-.5.1-.3.1-.5 0-.7-.1-.2-.9-2.2-1.3-3.1-.3-.8-.7-.7-.9-.7h-.8c-.3 0-.7.1-1.1.5-.4.4-1.5 1.4-1.5 3.4 0 .5.1 1 .2 1.4.4 1.5 1.3 2.6 1.5 2.9.2.3 2.9 4.6 7.1 6.2 4.2 1.6 4.2 1.1 5 1 .8-.1 2.5-1 2.8-2 .3-1 .3-1.8.2-2-.3-.1-.6-.2-1-.5z"
    />
  </svg>
)
export default WhatsApp
